import axios from "axios";
import { getSaveSupportTicketUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class SupportTicketRepository {
    async saveSupportTicket(ticketContent, contact) {
        const session = await supabase.auth.getSession()
        let headers = {}
        if (session != null && session.data.session != null) {
            headers = {
                'Authorization': `Bearer ${session.data.session.access_token}`
            }
        } else {
            headers = {}
        }
        const response = await axios.post(
            getSaveSupportTicketUrl(),
            {
                content: ticketContent,
                contact: contact
            },
            {
                headers: headers
            }
        );
        return response.data
    }
}
